export default __webpack_public_path__ + "static/media/eye.c9c458ce.svg";